import {
  Box,
  Button,
  Collapse,
  Divider,
  Grid,
  IconButton,
  Paper,
  Tab,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { TabContext, TabList, TabPanel } from "@mui/lab";

import { Add, Clear, DeleteOutline, KeyboardArrowUp, KeyboardArrowDown } from "@mui/icons-material";
import { color } from "../../../StyleData/Config";
import { masterAPI } from "../../Masters/dataConfig";
import { axiosPrivate } from "../../../axios/axios";
import { fromUTC } from "../../../utils/dateUtil";
import NormalTable from "../../../Component/NormalTable";
import { toast } from "react-toastify";
import Loading from "../../../Component/Loading";
import DocUpload from "../../../Component/DocUpload";
import { useSelector } from "react-redux";
import UnifiedModal from "../../../Component/UnifiedModal";
import { defaultInfo, SubMenu, woStatus, isSystemAccess } from "../../../ConfigInfo/Info";
import { decode } from "../../../Component/JWT/Formatt";
import Partlist from "./PartReservaltion/Partlist";
import CreatePart from "./PartReservaltion/CreatePart";

const SRView = ({
  viewId,
  handleCloseClick,
  isDialogOpen,
  approvalContext,
}) => {
  const id = decode(viewId);
  const actionsAllow = useSelector((state) => state.dataRed.actionsAllow);
  const subMenuList = useSelector((state) => state.dataRed.subMenuList);
  const menuArray = useSelector((state) => state.dataRed.menuArray);
  const siteInfoDetail = useSelector((state) => state.auth.loginInfo);
  const isSystem = isSystemAccess(siteInfoDetail);
  const canGenerate =
    Array.isArray(menuArray) &&
    menuArray.filter((item) => item.id === SubMenu.workorder)[0]?.create ===
      true;
  const [value, setValue] = useState("1");
  const [comDetail, setComDetail] = useState({});
  const [docData, setDocData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [add, setAdd] = useState(false);
  const [woData, setWoData] = useState([]);
  const [approvalStatus, setApprovalStatus] = useState(null);
  const [approvalLevel, setApprovalLevel] = useState(null); // Add this
  const [rejectedDescription, setRejectedDescription] = useState(""); // Add this
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectDescription, setRejectDescription] = useState("");
  const [remarkOpen, setRemarkOpen] = useState(true);
  const [enableDisablePartReservation, setEnableDisablePartReservation] =
    useState(
      subMenuList.filter((fil) => fil.id === SubMenu.partReservation)[0] || {},
    );
  const [partReservationValue, setPartReservationValue] = useState("1");

  useEffect(() => {
    getData();
    // Fetch approval status if coming from approval page
    if (approvalContext?.approvalId) {
      fetchApprovalStatus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getData = async () => {
    setLoading(true);
    const srLink = masterAPI["serviceRequest"].getByid;
    await axiosPrivate
      .get(`${srLink}/${id}`)
      .then((res) => {
        setComDetail(res.data.result);
      })
      .catch((e) => {
        setComDetail([]);
        console.log(e);
      });

    const docLink = masterAPI["serviceRequest"].getdocbyid;
    await axiosPrivate
      .get(`${docLink}/${id}`)
      .then((res) => {
        console.log(res);
        setDocData(res.data.result);
      })
      .catch((e) => {
        setDocData([]);
        console.log(e);
      });

    const woDataLink = masterAPI["workOrder"].getByServiceReqId;
    await axiosPrivate
      .get(`${woDataLink}/${id}`)
      .then((res) => {
        console.log(res);
        setWoData(res.data.statusCode === 204 ? [] : [res.data.result]);
      })
      .catch((e) => {
        setWoData([]);
        console.log(e);
      });
    setLoading(false);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleChangePartReservation = (event, newValue) => {
    setPartReservationValue(newValue);
  };

  const handleCancel = () => {
    handleCloseClick();
  };

  const handleDownload = async (id) => {
    const downloadLink = masterAPI["serviceRequest"].download;
    await axiosPrivate
      .get(`${downloadLink}/${id}`)
      .then((res) => {
        console.log(res);
        window.open(res.data.result.documentPath);
        //  window.open(`https://demo.orienseam.com/${res.data.result.documentName}}`)
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const handleDelete = async (id) => {
    const deleteLink = masterAPI["serviceRequest"].deleteDoc;
    console.log(`${deleteLink}/${id}`);
    await axiosPrivate
      .delete(`${deleteLink}/${id}`)
      .then((res) => {
        console.log(res.data);
        getData();
      })
      .catch((e) => {
        console.log(e, "delete Doc");
      });
  };

  const columns = [
    {
      Header: "Doc Name",
      accessor: "documentName",
      Cell: ({ cell }) => {
        return (
          <Typography
            sx={{
              fontSize: "inherit",
              fontWeight: "inherit",
              color: "blue",
              cursor: "pointer",
            }}
            onClick={() => {
              handleDownload(cell.row.original.id);
            }}
          >
            {cell.value.split("/")[2].split("_")[1]}
          </Typography>
        );
      },
    },
    {
      Header: "Doc Type",
      accessor: "documenttype",
    },
    {
      Header: "Actions",
      Cell: ({ cell }) => {
        return (
          <Box sx={{ whiteSpace: "nowrap" }}>
            <IconButton
              disabled={
                comDetail.status !== "NEW" || actionsAllow.edit === false
              }
              onClick={() => {
                handleDelete(cell.row.original.id);
              }}
            >
              <DeleteOutline
                sx={{
                  fontSize: color.masterEditDelButton,
                  color: color.masterEditDelButtonColor,
                }}
              />
            </IconButton>
          </Box>
        );
      },
    },
  ];

  const columnWO = [
    {
      Header: "Workorder Code",
      accessor: "code",
      Cell: ({ cell }) => {
        return (
          <Typography
            sx={{
              fontSize: "inherit",
              fontWeight: "inherit",
              color: "blue",
              cursor: "pointer",
            }}
          >
            {cell.value}
          </Typography>
        );
      },
    },
    {
      Header: "Workorder Name",
      accessor: "workOrderName",
    },
    {
      Header: "Responsible Person",
      accessor: "responsiblePersonName",
    },
    {
      Header: "Status",
      accessor: "status",
    },
    {
      Header: "Planned Start Date",
      accessor: "plannedStartDate",
      Cell: ({ cell }) => {
        return (
          <Typography sx={{ fontSize: "inherit", fontWeight: "inherit" }}>
            {cell.value !== null && cell.value !== undefined
              ? fromUTC(cell.value).tzString
              : "---"}
          </Typography>
        );
      },
    },
    {
      Header: "Planned End Date",
      accessor: "plannedEndDate",
      Cell: ({ cell }) => {
        return (
          <Typography sx={{ fontSize: "inherit", fontWeight: "inherit" }}>
            {cell.value !== null && cell.value !== undefined
              ? fromUTC(cell.value).tzString
              : "---"}
          </Typography>
        );
      },
    },
  ];

  const handleGenerate = async () => {
    const genWo = masterAPI["serviceRequest"].coverttowo;

    await axiosPrivate
      .put(`${genWo}/${id}`)
      .then((res) => {
        console.log(res, "genWO");
        // toast.success(res.data.message);
        getData();
        //    setPmGen([])
      })
      .catch((e) => {
        console.log(e, "error generate workorder pm");
      });
  };

  const handleUpload = async (value) => {
    const doclink = masterAPI["serviceRequest"].uploadDoc;
    const uploadData = {
      serviceRequestId: id,
      ...value,
    };
    console.log(uploadData, "upload doc");
    await axiosPrivate
      .post(`${doclink}`, uploadData)
      .then((res) => {
        console.log(res);
        // toast.success(res.data.message);
        // handleClose();
        getData();
      })
      .catch((e) => {
        console.log(e, "error doc wo ");
      });
  };

  const fetchApprovalStatus = async () => {
    if (!approvalContext?.approvalId) return;

    const link = masterAPI["workFlowApproval"].link;
    await axiosPrivate
      .get(`${link}`)
      .then((res) => {
        const approvalRecord = res.data.result.find(
          (item) => item.id === approvalContext.approvalId,
        );
        if (approvalRecord) {
          setApprovalStatus(approvalRecord.status);
          setApprovalLevel(approvalRecord.workFlowLevel || null);
          setRejectedDescription(approvalRecord.description || "");
        }
      })
      .catch((e) => {
        console.log(e, "fetch approval status error");
      });
  };

  const handleApprove = async () => {
    if (!approvalContext?.approvalId) return;

    const updateLink = masterAPI["workFlowApproval"].update;
    const payload = {
      id: approvalContext.approvalId,
      status: "Approved",
    };

    await axiosPrivate
      .put(`${updateLink}`, payload)
      .then((res) => {
        console.log(res.data);
        setApprovalStatus("Approved");
        // toast.success("Request approved successfully");
        // Don't close immediately, let user see the status change
        setTimeout(() => {
          handleCloseClick();
        }, 1500);
      })
      .catch((e) => {
        console.log(e, "approve error");
        // toast.error(
        //   e.response?.data?.failureMessage || "Failed to approve request",
        // );
      });
  };

  const handleReject = async () => {
    if (!approvalContext?.approvalId) return;
    if (!rejectDescription.trim()) {
      toast.error("Description is required to reject.");
      return;
    }
    const updateLink = masterAPI["workFlowApproval"].update;
    const payload = {
      id: approvalContext.approvalId,
      status: "Rejected",
      description: rejectDescription,
    };
    await axiosPrivate
      .put(`${updateLink}`, payload)
      .then((res) => {
        setApprovalStatus("Rejected");
        // toast.success("Request rejected successfully");
        setShowRejectModal(false);
        setRejectDescription("");
        setTimeout(() => {
          handleCloseClick();
        }, 1500);
      })
      .catch((e) => {
        // toast.error(
        //   e.response?.data?.failureMessage || "Failed to reject request",
        // );
      });
  };

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <Box sx={{ p: color.masterPageDialogPadding }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              alignItems: "center",
            }}
          >
            <Typography
              sx={{
                fontSize: color.AssetTitlesize,
                fontWeight: color.sideFontWeightAsset,
              }}
            >
              {comDetail.code + "-" + comDetail.serviceRequestName}
            </Typography>
            <IconButton onClick={handleCancel}>
              <Clear />
            </IconButton>
          </Box>
          <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)" }} />

          {(comDetail.reasontoCancel || (approvalStatus === "Rejected" && rejectedDescription)) && (
            <Paper variant="outlined" sx={{ my: 1, borderRadius: 1, overflow: "hidden" }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  px: 1.5,
                  py: 0.75,
                  cursor: "pointer",
                  backgroundColor: "#f5f5f5",
                }}
                onClick={() => setRemarkOpen((prev) => !prev)}
              >
                <Typography sx={{ fontSize: "13px", fontWeight: 600, color: color.masterPageTitleColor }}>
                  Remark
                </Typography>
                <IconButton size="small" disableRipple>
                  {remarkOpen ? <KeyboardArrowUp fontSize="small" /> : <KeyboardArrowDown fontSize="small" />}
                </IconButton>
              </Box>
              <Collapse in={remarkOpen}>
                <Box
                  sx={{
                    px: 1.5,
                    py: 1,
                    borderTop: "1px solid #e0e0e0",
                    display: "flex",
                    flexDirection: "column",
                    gap: 0.5,
                    backgroundColor: "#fff",
                  }}
                >
                  {(comDetail.workFlowLevel || approvalLevel) && (
                    <Typography sx={{ fontSize: "13px", color: "#1976d2", fontWeight: 500 }}>
                      Workflow Level: {comDetail.workFlowLevel || approvalLevel}
                    </Typography>
                  )}
                  <Typography sx={{ fontSize: "13px", color: "#d32f2f", fontWeight: 500 }}>
                    Rejection Reason:
                    <span style={{ fontWeight: 400, color: "#333", display: "block", wordBreak: "break-word", overflowWrap: "anywhere" }}>
                      {comDetail.reasontoCancel || rejectedDescription}
                    </span>
                  </Typography>
                </Box>
              </Collapse>
            </Paper>
          )}

          <TabContext value={value}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <TabList onChange={handleChange} aria-label="SR view">
                <Tab label="General" value="1" />
                <Tab label="Document" value="2" />
                <Tab label="Work Order" value="3" />
              </TabList>
            </Box>
            <TabPanel value="1" sx={{ p: 0, pt: 1 }}>
              <Grid container spacing={"1rem"}>
                <Grid item xs={12} md={6}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Service Request
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: color.TabDatafontsize,
                      mb: color.TabDatamarginbottom,
                    }}
                  >
                    {comDetail.serviceRequestName}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Description
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: color.TabDatafontsize,
                      mb: color.TabDatamarginbottom,
                    }}
                  >
                    {comDetail.description === ""
                      ? "---"
                      : comDetail.description}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Asset
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: color.TabDatafontsize,
                      mb: color.TabDatamarginbottom,
                    }}
                  >
                    {comDetail.assetCode + "-" + comDetail.assetName}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Location
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: color.TabDatafontsize,
                      mb: color.TabDatamarginbottom,
                    }}
                  >
                    {comDetail.locationCode + "-" + comDetail.locationName}
                  </Typography>
                </Grid>
                {isSystem && (
                  <Grid item xs={12} md={6}>
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        mb: color.labelmb,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      System
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: color.TabDatafontsize,
                        mb: color.TabDatamarginbottom,
                      }}
                    >
                      {comDetail.systemName
                        ? comDetail.systemCode + "-" + comDetail.systemName
                        : "--"}
                    </Typography>
                  </Grid>
                )}
                <Grid item xs={12} md={6}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Failure Class
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: color.TabDatafontsize,
                      mb: color.TabDatamarginbottom,
                    }}
                  >
                    {comDetail.failureClassCode +
                      "-" +
                      comDetail.failureClassName}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Problem Code
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: color.TabDatafontsize,
                      mb: color.TabDatamarginbottom,
                    }}
                  >
                    {comDetail.problemCode + "-" + comDetail.problemName}
                  </Typography>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Work Type
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: color.TabDatafontsize,
                      mb: color.TabDatamarginbottom,
                    }}
                  >
                    {comDetail.workTypeName}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={6}
                  sx={{ ".css-1xhypcz-MuiStack-root": { paddingTop: 0 } }}
                >
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      // mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Requested Date
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: color.TabDatafontsize,
                      mb: color.TabDatamarginbottom,
                    }}
                  >
                    {comDetail.requestedDate
                      ? fromUTC(comDetail.requestedDate).tzString
                      : "---"}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={6}
                  sx={{ ".css-1xhypcz-MuiStack-root": { paddingTop: 0 } }}
                >
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      // mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Stop Begin Date
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: color.TabDatafontsize,
                      mb: color.TabDatamarginbottom,
                    }}
                  >
                    {comDetail.stopBeginDate
                      ? fromUTC(comDetail.stopBeginDate).tzString
                      : "---"}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={6}
                  sx={{ ".css-1xhypcz-MuiStack-root": { paddingTop: 0 } }}
                >
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      // mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Status
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: color.TabDatafontsize,
                      mb: color.TabDatamarginbottom,
                    }}
                  >
                    {comDetail.status}
                  </Typography>
                </Grid>
                <Grid
                  container
                  item
                  xs={12}
                  md={12}
                  justifyContent={"flex-end"}
                  gap={"1rem"}
                >
                  {approvalContext?.fromApproval && (
                    <>
                      {approvalStatus === "Pending" && (
                        <>
                          <Button
                            variant="contained"
                            sx={{
                              backgroundColor: "green",
                              fontSize: color.fontSize,
                              borderRadius: "2px",
                              boxShadow: "0px 5px 10px #00000033",
                              "&:hover": {
                                backgroundColor: "darkgreen",
                              },
                            }}
                            onClick={handleApprove}
                          >
                            Approve
                          </Button>
                          <Button
                            variant="contained"
                            sx={{
                              backgroundColor: "red",
                              fontSize: color.fontSize,
                              borderRadius: "2px",
                              boxShadow: "0px 5px 10px #00000033",
                              "&:hover": {
                                backgroundColor: "darkred",
                              },
                            }}
                            onClick={() => setShowRejectModal(true)}
                          >
                            Reject
                          </Button>
                        </>
                      )}
                    </>
                  )}
                  {(comDetail.status === woStatus.APPR ||
                    comDetail.status === woStatus.OPEN) && (
                    <Button
                      variant="contained"
                      disabled={
                        !canGenerate ||
                        comDetail.status === woStatus.CAN ||
                        comDetail.status === woStatus.WOCREATED ||
                        comDetail.status === woStatus.CLOSE
                      }
                      sx={{
                        backgroundColor: color.TableButtonColor,
                        fontSize: color.fontSize,
                        borderRadius: "2px",
                        boxShadow: "0px 5px 10px #00000033",
                        display: isDialogOpen ? "none" : "default",
                      }}
                      onClick={handleGenerate}
                    >
                      Generate
                    </Button>
                  )}
                </Grid>
              </Grid>
            </TabPanel>
            <TabPanel value="2" sx={{ p: 0, pt: 1 }}>
              <Box
                sx={{ display: "flex", gap: "1rem", flexDirection: "column" }}
              >
                <Paper elevation={3} sx={{ p: 1 }}>
                  <Grid container>
                    <Grid container item xs={12} justifyContent={"flex-end"}>
                      <IconButton
                        disabled={
                          comDetail.status !== "NEW" ||
                          actionsAllow.edit === false
                        }
                        sx={{ display: isDialogOpen ? "none" : "default" }}
                        onClick={() => {
                          setAdd(true);
                        }}
                      >
                        <Add />
                      </IconButton>
                    </Grid>
                    <Grid item xs={12}>
                      <NormalTable columns={columns} data={docData} />
                    </Grid>
                  </Grid>
                </Paper>
                <Paper
                  elevation={3}
                  sx={{ p: 1, display: add ? "default" : "none" }}
                >
                  <DocUpload
                    handleUpload={handleUpload}
                    handleCloseClick={() => {
                      setAdd(false);
                    }}
                  />
                </Paper>
              </Box>
            </TabPanel>
            <TabPanel value="3" sx={{ p: 0, pt: 1 }}>
              <Grid container item xs={12}>
                <NormalTable columns={columnWO} data={woData} />
                {woData.length !== 0 &&
                  (comDetail.workTypeCode === defaultInfo.workType.OPERATION ||
                    comDetail.workTypeCode ===
                      defaultInfo.workType.FACILITY) && (
                    <>
                      {/* <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)" }} /> */}
                      <Box
                        sx={{
                          display: "flex",
                          borderBottom: "1px solid #ddd",
                          mt: 2,
                        }}
                      >
                        <Button
                          onClick={() => handleChangePartReservation(null, "1")}
                          sx={{
                            textTransform: "uppercase",
                            borderRadius: 0,
                            px: 2,
                            py: 1,
                            color:
                              partReservationValue === "1" ? "#1976d2" : "#555",
                            borderBottom:
                              partReservationValue === "1"
                                ? "3px solid #1976d2"
                                : "3px solid transparent",
                            fontWeight: 500,
                          }}
                        >
                          Part Reservation List
                        </Button>

                        <Button
                          onClick={() => handleChangePartReservation(null, "2")}
                          disabled={
                            !enableDisablePartReservation.create ||
                            woData[0]?.status?.toUpperCase() === woStatus.PPRAPPR ||
                            woData[0]?.status?.toUpperCase() === woStatus.PAPPR ||
                            woData[0]?.status?.toUpperCase() === woStatus.PENAPP ||
                            woData[0]?.status?.toUpperCase() === woStatus.RESUBMIT ||
                            woData[0]?.status?.toUpperCase() === woStatus.PRREJT
                          }
                          sx={{
                            textTransform: "uppercase",
                            borderRadius: 0,
                            px: 2,
                            py: 1,
                            color:
                              partReservationValue === "2" ? "#1976d2" : "#555",
                            borderBottom:
                              partReservationValue === "2"
                                ? "3px solid #1976d2"
                                : "3px solid transparent",
                            fontWeight: 500,
                          }}
                        >
                          Create Part Reservation
                        </Button>
                      </Box>

                      {partReservationValue === "1" && (
                        <Partlist
                          workOrderId={woData[0]?.id}
                          enableDisable={enableDisablePartReservation}
                          printName={woData[0].code+" - "+woData[0].workOrderName+" - "+"Reservation"}
                        />
                      )}

                      {partReservationValue === "2" && (
                        <CreatePart
                          workOrderId={woData[0]?.id}
                          handleClose={() =>
                            handleChangePartReservation(null, "1")
                          }
                        />
                      )}
                    </>
                  )}
              </Grid>
            </TabPanel>
          </TabContext>
        </Box>
      )}
      <UnifiedModal
        open={showRejectModal}
        onClose={() => setShowRejectModal(false)}
        title="Reject Request"
        description="Please provide a reason for rejection:"
        inputLabel="Rejection Description"
        inputValue={rejectDescription}
        onInputChange={(e) => setRejectDescription(e.target.value)}
        onCancel={() => setShowRejectModal(false)}
        onReject={handleReject}
        rejectButtonColor="error"
        rejectButtonVariant="contained"
        minRows={2}
        autoFocus={true}
      />
    </>
  );
};

export default SRView;
